import React from 'react';
import PropTypes from 'prop-types';
import ClientPortal from './client-portal.component.js';
import { UserTenantProps, hasAccess } from 'cp-client-auth!sofe';
import { getAvailableTabs } from './client-tab.helpers.js';
import {captureMessage} from 'sentry-error-logging!sofe';
import { fetchClients, getWithCacheWhiteLabelSettings, getTaxReturns } from './clients.resource.js';
import {catchAsyncStacktrace} from 'auto-trace';
import Cancelable from 'react-disposable-decorator';
import { map, pick} from 'lodash';
import { getCanopyPaymentsStatus } from './billing.resource.js';

@Cancelable
@UserTenantProps()
export default class ClientPortalContainer extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    tenant: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props);
    this.state = {
      tenant: props.tenant,
      user: props.user,
      clients: [],
      activeClient: null,
      hash: window.location.hash,
      whiteLabelSettings: null,
      hasCanopyPayments: false,
      showTaxReturns: null
    };

    this.actions = {
      setClients: clients => { this.setState({clients}) },
      setActiveClient: activeClient => { this.setState({activeClient}) },
      hashChange: () => {
        const clientId = getClientId();
        const activeClient = this.state.clients.find(client => client.id === Number(clientId)) || this.state.activeClient;
        this.setState({activeClient, hash: window.location.hash});
      },
    };
  }

  componentDidUpdate() {
    if (getClientId() && this.state.showTaxReturns === null) {
      this.setState({ showTaxReturns: false }, () => {
        if (hasAccess(this.state.user)(['client_tax_prep'])) {
          this.props.cancelWhenUnmounted(
            getTaxReturns(getClientId()).subscribe(taxReturns => {
              const showTaxReturns = !!taxReturns.find(taxReturn => taxReturn.shared);
              this.setState({showTaxReturns});
            }, catchAsyncStacktrace())
          );
        }
      });
    }
  }

  componentDidMount() {
    this.props.cancelWhenUnmounted(
      getWithCacheWhiteLabelSettings()
      .subscribe(
        settings => {
          this.setState({ whiteLabelSettings: settings })
        },
        catchAsyncStacktrace()
      )
    );

    fetchClients()
    .then((clients = []) => {
      if (clients.length > 0) {
        this.actions.setClients(clients);
        const clientId = getClientId();
        const activeClient = clients.find(client => client.id === Number(clientId)) || clients[0];
        this.actions.setActiveClient(activeClient);

        if (clients.length >= 30) {
          // TEMP SENTRY LOG FOR DEBUGGING
          const userData = pick(this.props.loggedInUser, ['id', 'effective_permissions', 'permissions', 'role', 'loginAttempts', 'lastLogin']);
          const clientIds = map(clients, 'id');
          captureMessage("Potential Client Portal Access Violation", {level: 'info', extra: {userData, clientIds, numClients: clientIds.length, activeClientId: activeClient.id}});
        }
      }
    });

    this.props.cancelWhenUnmounted(
      getCanopyPaymentsStatus().subscribe(response => {
        this.setState({ hasCanopyPayments: response.status.is_active });
      }, catchAsyncStacktrace())
    );

    window.addEventListener("hashchange", this.actions.hashChange);
  }
  componentWillUnmount() {
    window.removeEventListener("hashchange", this.actions.hashChange);
  }
  render() {
    const { hasCanopyPayments, whiteLabelSettings, tenant, user, activeClient, showTaxReturns } = this.state;
    const tabs = getAvailableTabs(tenant, user, activeClient).filter(tab => {
      return showTaxReturns || tab.id !== "tax_returns"
    });

    return (
      <div ref={el => this.rootEl = el}>
        <ClientPortal
          {...this.state}
          actions={this.actions}
          tabs={tabs}
          logo_url={whiteLabelSettings?.logo_url}
          company_name={whiteLabelSettings?.company_name}
          hasCanopyPayments={hasCanopyPayments}
          customLinks={whiteLabelSettings?.custom_links?.filter(link => link.enabled)}
          companyWebsiteLink={whiteLabelSettings?.company_website_link}
          appointmentSchedulerLink={whiteLabelSettings?.appointment_scheduler_link}
        />
      </div>
    );
  }
}

function getClientId() {
  const matches = /client[s]?\/([0-9]+)/.exec(window.location.hash);
  return matches ? matches[1] : null;
}
